import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { ICreateEventTopicPayload } from '@app-store/slices/eventTopics/createEventTopic'

interface TaskAction extends Action {
    payload: ICreateEventTopicPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.eventTopics.create

function* createEventTopicSagaTask({ payload }) {
    try {
        const response = yield axios.post(`/event/event-topic`, payload.data)
        if (response.success) {
            yield put(onSuccess(response.result))
            yield payload.sagaCB?.onSuccess(response.result)
        } else {
            throw new Error('')
        }
    } catch (error) {
        // console.log(error)
        yield put(onFailure(error))
    }
}

function* createEventTopicSaga(): any {
    yield takeLatest<TaskAction>(onRequest, createEventTopicSagaTask)
}

export default createEventTopicSaga
